export function checkHost() {
  if (/(staging-)?clip\.kalowave.com$/.test(location.host) === false) {
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    } else {
      window.location.href = "https://clip.kalowave.com";
    }
  }
}
